export default {"src":"/_next/static/media/Experiance.7419aacd.svg","height":19,"width":21,"blurWidth":0,"blurHeight":0};